import { CountryCode } from '@cineamo/api/types/CountryCode';

import { Locale } from '../constants/locale-constants';

import { ISO_639_1_LOCALE, ISO_3166_1_LOCALE } from './locale-helper';

// Type guard for Locale enum
export function isLocale(value: string): value is Locale {
    return Object.values(Locale).includes(value as Locale);
}

// Type guard for ISO_639_1_LOCALE (2 lowercase letters)
export function isISO_639_1(value: string): value is ISO_639_1_LOCALE {
    return /^[a-z]{2}$/.test(value);
}

// Type guard for ISO_3166_1_LOCALE (2 uppercase letters)
export function isISO_3166_1(value: string): value is ISO_3166_1_LOCALE {
    return /^[A-Z]{2}$/.test(value);
}

// Safe conversion functions using type guards
export function toISO_639_1(value: string): ISO_639_1_LOCALE | undefined {
    if (!value) return undefined;
    const processed = value.substring(0, 2).toLowerCase();
    return isISO_639_1(processed) ? processed : undefined;
}

export function toISO_3166_1(value: string): ISO_3166_1_LOCALE | undefined {
    if (!value) return undefined;
    const processed = value.substring(0, 2).toUpperCase();
    return isISO_3166_1(processed) ? processed : undefined;
}

// Type guard for API CountryCode
export function isApiCountryCode(value: string): value is CountryCode {
    const validCodes: CountryCode[] = ['DE', 'AT', 'CH', 'US', 'NL', 'GB'];
    return validCodes.includes(value as CountryCode);
}

// Safe conversion from ISO_3166_1_LOCALE to API CountryCode
export function toApiCountryCode(iso: ISO_3166_1_LOCALE | undefined): CountryCode | undefined {
    if (!iso) return undefined;
    return isApiCountryCode(iso) ? iso : undefined;
}
